import React, { useEffect, useState, useRef } from 'react';
import { Link, useParams } from 'react-router-dom';

import Axios from 'axios';
import _ from 'lodash';

import { PrimeIcons } from 'primereact/api';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { SelectButton } from 'primereact/selectbutton';

import Config from '../config';

const ExcludeFromUpdates = () => {
    const [rowsCount, setRowsCount] = useState();
    const [rows, setRows] = useState([]);
    const [vendors, setVendors] = useState([]);
    const [loading, setLoading] = useState(true);
    const [lazyParams, setLazyParams] = useState({
        first: 0,
        rows: 20,
        page: 1,
        sortField: 'id',
        sortOrder: -1,
        filters: {
            'aic': { value: null, matchMode: 'equals' },
            'vendor': { value: null, matchMode: 'equals' },
            'title': { value: null, matchMode: 'equals' }
        }
    });
    const [vendorSelected, setVendorSelected] = useState([]);

    const aicRef = useRef();
    const vendorRef = useRef();

    useEffect(() => {
        loadLazyData();
    }, [lazyParams]);

    const loadLazyData = () => {
        setLoading(true);

        Axios.post(Config.API_BASE_URL+"/api/settings/exclude-from-updates", lazyParams)
            .then(result => result.data)
            .then(result => {
                setRows(result.data.rows);
                setRowsCount(result.data.count);
                setLoading(false);
            });

        Axios.get(Config.API_BASE_URL+"/api/vendors")
            .then(result => result.data)
            .then(result => {
                setVendors(result.data.rows);
            });
    };

    const onFilter = params => {
        setLazyParams(_.merge(params, { first: 0 }));
    }
    const onSort = params => setLazyParams(params);
    const onPage = params => setLazyParams(params);

    const vendorRowFilterTemplate = options => (
        <Dropdown
          value={options.value}
          options={vendors}
          optionLabel="name"
          onChange={(e) => options.filterApplyCallback(e.value)}
          placeholder="Scegli un produttore"
          className="p-column-filter"
        />
    );

    const deleteButton = row => (
        <div className="actions">
            <Button
                icon={PrimeIcons.TRASH}
                className="p-button-rounded p-button-danger"
                onClick={() => deleteRow(row)}
            />
        </div>
    );

    const deleteRow = row => {
        setLoading(true);

        Axios.delete(Config.API_BASE_URL+"/api/settings/exclude-from-updates/"+row.id)
            .then(() => {
                loadLazyData();
            });
    };

    const addRow = () => {
        setLoading(true);

        Axios.post(Config.API_BASE_URL+"/api/settings/add-exclude-from-updates", { aic: aicRef.current.value, vendor: vendorSelected })
            .then(() => {
                aicRef.current.value = '';
                vendorRef.current.value = '';
                loadLazyData();
            });
    };

    return (
        <div className="grid">
            <div className="col-12">
                <div className="card">
                    <h5>Elenco dei prodotti esclusi dagli aggiornamenti</h5>
                    <DataTable
                      className="p-datatable-gridlines"
                      responsiveLayout="scroll"
                      lazy
                      dataKey="id"
                      value={rows}
                      paginator
                      showGridlines
                      first={lazyParams.first}
                      rows={lazyParams.rows}
                      totalRecords={rowsCount}
                      filters={lazyParams.filters}
                      filterDisplay="row"
                      onFilter={onFilter}
                      sortField={lazyParams.sortField}
                      sortOrder={lazyParams.sortOrder}
                      onSort={onSort}
                      onPage={onPage}
                      loading={loading}
                      emptyMessage="Nessun prodotto trovato."
                    >
                      <Column key="aic" header="AIC" field="aic" filter showFilterMenu={false} style={{ maxWidth: '100px' }} />
                      <Column field="vendor" filter showFilterMenu={false} filterElement={vendorRowFilterTemplate} header="Produttore" />
                      <Column body={deleteButton} style={{ maxWidth: '50px' }} />
                    </DataTable>
                </div>

                <div className="card">
                    <h5>Aggiungi un AIC da escludere</h5>
                    <div className="formgroup-inline">
                        <div className="field">
                            <label htmlFor="aic" className="p-sr-only">AIC</label>
                            <InputText ref={aicRef} id="aic" type="text" />
                        </div>
                        <div className="field">
                            <label htmlFor="feed" className="p-sr-only">Produttore</label>
                            <Dropdown
                                ref={vendorRef}
                                value={vendorSelected}
                                onChange={e => setVendorSelected(e.value)}
                                options={vendors}
                                optionLabel="name"
                            />
                        </div>
                        <Button label="Submit" onClick={() => addRow()}></Button>
                    </div>
                </div>
            </div>
        </div>
    );
}

const comparisonFn = function (prevProps, nextProps) {
    return prevProps.location.pathname === nextProps.location.pathname;
};

export default React.memo(ExcludeFromUpdates, comparisonFn);
